import * as Sentry from "@sentry/react-native";
import { atom } from "jotai";

import { BookingWizard } from "@/features/BookingWizard/types";

import { BookingWizardDataAtom } from "../../stores";

export const setCourseIdAtom = atom(
  null,
  (
    get,
    set,
    {
      courseId,
      startSlotId,
    }: { courseId: string | null; startSlotId: string | null }
  ) => {
    const bookingWizardData = get(BookingWizardDataAtom);
    if (!bookingWizardData) {
      Sentry.captureException("Booking wizard data is null");

      return;
    }

    if (
      bookingWizardData.type !== "DurationBooking" &&
      bookingWizardData.type !== "LessonBooking"
    ) {
      Sentry.captureException(
        "Booking wizard data is not a duration booking or lesson booking"
      );
      return;
    }

    const newBookingWizardData:
      | BookingWizard.DurationBookingWizardData
      | BookingWizard.LessonBookingWizardData = {
      ...bookingWizardData,
      courseId: courseId,
      startSlotId: startSlotId,
    };

    set(BookingWizardDataAtom, newBookingWizardData);
  }
);
